import { render, staticRenderFns } from "./DashboardMenuBranch.vue?vue&type=template&id=45252a96&scoped=true"
import script from "./DashboardMenuBranch.vue?vue&type=script&lang=js"
export * from "./DashboardMenuBranch.vue?vue&type=script&lang=js"
import style0 from "./DashboardMenuBranch.vue?vue&type=style&index=0&id=45252a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45252a96",
  null
  
)

export default component.exports